var TorsoNestedModel = require('backbone-torso/modules/NestedModel');

/**
 * Model representing a form.
 * @class FormModel.js
 * @constructor
 * @extends Torso.NestedModel
 */
module.exports = TorsoNestedModel.extend({
  idAttribute: 'formName'
});
